import { useTheme } from 'styled-components'

import { IconBase, IconProps } from './Base'

export const IconWallet = (props: IconProps) => {
  const theme = useTheme()

  return (
    <IconBase width={props.width || 32} height={props.height || 32} viewBox="0 0 32 32" fill="none">
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M25.3333 9.33333V5.33333C25.3333 4.97971 25.1929 4.64057 24.9428 4.39052C24.6928 4.14048 24.3536 4 24 4H6.66667C5.95942 4 5.28115 4.28095 4.78105 4.78105C4.28095 5.28115 4 5.95942 4 6.66667C4 7.37391 4.28095 8.05219 4.78105 8.55229C5.28115 9.05238 5.95942 9.33333 6.66667 9.33333H26.6667C27.0203 9.33333 27.3594 9.47381 27.6095 9.72386C27.8595 9.97391 28 10.313 28 10.6667V16M28 16H24C23.2928 16 22.6145 16.281 22.1144 16.781C21.6143 17.2811 21.3333 17.9594 21.3333 18.6667C21.3333 19.3739 21.6143 20.0522 22.1144 20.5523C22.6145 21.0524 23.2928 21.3333 24 21.3333H28C28.3536 21.3333 28.6928 21.1929 28.9428 20.9428C29.1929 20.6928 29.3333 20.3536 29.3333 20V17.3333C29.3333 16.9797 29.1929 16.6406 28.9428 16.3905C28.6928 16.1405 28.3536 16 28 16Z"
        stroke={theme.colors.text.primary}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M4 6.66602V25.3327C4 26.0399 4.28095 26.7182 4.78105 27.2183C5.28115 27.7184 5.95942 27.9993 6.66667 27.9993H26.6667C27.0203 27.9993 27.3594 27.8589 27.6095 27.6088C27.8595 27.3588 28 27.0196 28 26.666V21.3327"
        stroke={theme.colors.text.primary}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconBase>
  )
}
